/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 页面终端：product_detail_pc（83 个 D 位坑位，15 个 C 位模块）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const PRODUCT_DETAIL_PC_SPM_CODES = {
  accessory_recommendations: {
    code: `${sitePrefix}.product_detail_pc.accessory_recommendations`,
    'add_to_cart_{NNN}': `${sitePrefix}.product_detail_pc.accessory_recommendations.add_to_cart_{NNN}`,
    'favorite_{NNN}': `${sitePrefix}.product_detail_pc.accessory_recommendations.favorite_{NNN}`,
    'preview_accessory_{NNN}': `${sitePrefix}.product_detail_pc.accessory_recommendations.preview_accessory_{NNN}`,
  },
  breadcrumb: {
    code: `${sitePrefix}.product_detail_pc.breadcrumb`,
    'breadcrumb_item_{NN}': `${sitePrefix}.product_detail_pc.breadcrumb.breadcrumb_item_{NN}`,
  },
  color_variants: {
    code: `${sitePrefix}.product_detail_pc.color_variants`,
    'select_variant_{NN}': `${sitePrefix}.product_detail_pc.color_variants.select_variant_{NN}`,
  },
  detail_navigation: {
    code: `${sitePrefix}.product_detail_pc.detail_navigation`,
    view_description: `${sitePrefix}.product_detail_pc.detail_navigation.view_description`,
    view_lens_details: `${sitePrefix}.product_detail_pc.detail_navigation.view_lens_details`,
    view_reviews: `${sitePrefix}.product_detail_pc.detail_navigation.view_reviews`,
    view_shipping_returns: `${sitePrefix}.product_detail_pc.detail_navigation.view_shipping_returns`,
    view_specifications: `${sitePrefix}.product_detail_pc.detail_navigation.view_specifications`,
  },
  frame_specifications: {
    code: `${sitePrefix}.product_detail_pc.frame_specifications`,
    material_entry: `${sitePrefix}.product_detail_pc.frame_specifications.material_entry`,
    shape_entry: `${sitePrefix}.product_detail_pc.frame_specifications.shape_entry`,
    toggle_measurement_unit: `${sitePrefix}.product_detail_pc.frame_specifications.toggle_measurement_unit`,
  },
  installment_information: {
    code: `${sitePrefix}.product_detail_pc.installment_information`,
    open_installment_details: `${sitePrefix}.product_detail_pc.installment_information.open_installment_details`,
  },
  lens_availability: {
    code: `${sitePrefix}.product_detail_pc.lens_availability`,
    toggle_lens_availability: `${sitePrefix}.product_detail_pc.lens_availability.toggle_lens_availability`,
  },
  price_offers: {
    code: `${sitePrefix}.product_detail_pc.price_offers`,
    open_coupons: `${sitePrefix}.product_detail_pc.price_offers.open_coupons`,
    open_first_frame_offer: `${sitePrefix}.product_detail_pc.price_offers.open_first_frame_offer`,
    open_second_frame_offer: `${sitePrefix}.product_detail_pc.price_offers.open_second_frame_offer`,
  },
  product_gallery: {
    code: `${sitePrefix}.product_detail_pc.product_gallery`,
    'select_image_{NN}': `${sitePrefix}.product_detail_pc.product_gallery.select_image_{NN}`,
    'toggle_dimensions_{NN}': `${sitePrefix}.product_detail_pc.product_gallery.toggle_dimensions_{NN}`,
    try_on: `${sitePrefix}.product_detail_pc.product_gallery.try_on`,
  },
  product_summary: {
    code: `${sitePrefix}.product_detail_pc.product_summary`,
    add_to_cart: `${sitePrefix}.product_detail_pc.product_summary.add_to_cart`,
    favorite: `${sitePrefix}.product_detail_pc.product_summary.favorite`,
    frame_only: `${sitePrefix}.product_detail_pc.product_summary.frame_only`,
    no_restock: `${sitePrefix}.product_detail_pc.product_summary.no_restock`,
    notify_me_when_available: `${sitePrefix}.product_detail_pc.product_summary.notify_me_when_available`,
    notify_me_when_in_stock: `${sitePrefix}.product_detail_pc.product_summary.notify_me_when_in_stock`,
    select_lenses: `${sitePrefix}.product_detail_pc.product_summary.select_lenses`,
    select_lenses_and_buy: `${sitePrefix}.product_detail_pc.product_summary.select_lenses_and_buy`,
    subscribed: `${sitePrefix}.product_detail_pc.product_summary.subscribed`,
    view_reviews: `${sitePrefix}.product_detail_pc.product_summary.view_reviews`,
  },
  review_filters: {
    code: `${sitePrefix}.product_detail_pc.review_filters`,
    open_review_sort: `${sitePrefix}.product_detail_pc.review_filters.open_review_sort`,
    'review_filter_option_{NN}': `${sitePrefix}.product_detail_pc.review_filters.review_filter_option_{NN}`,
  },
  review_pagination: {
    code: `${sitePrefix}.product_detail_pc.review_pagination`,
    next_page: `${sitePrefix}.product_detail_pc.review_pagination.next_page`,
    'page_number_{NN}': `${sitePrefix}.product_detail_pc.review_pagination.page_number_{NN}`,
    previous_page: `${sitePrefix}.product_detail_pc.review_pagination.previous_page`,
  },
  review_results: {
    code: `${sitePrefix}.product_detail_pc.review_results`,
    'mark_review_helpful_{NNN}': `${sitePrefix}.product_detail_pc.review_results.mark_review_helpful_{NNN}`,
  },
  services_guarantees: {
    code: `${sitePrefix}.product_detail_pc.services_guarantees`,
    open_fsa_hsa_details: `${sitePrefix}.product_detail_pc.services_guarantees.open_fsa_hsa_details`,
    toggle_services_guarantees: `${sitePrefix}.product_detail_pc.services_guarantees.toggle_services_guarantees`,
  },
  size_guide_entry: {
    code: `${sitePrefix}.product_detail_pc.size_guide_entry`,
    open_size_chart: `${sitePrefix}.product_detail_pc.size_guide_entry.open_size_chart`,
  },
} as const satisfies SpmPageCodes;
